export default {
      id: "Icon--play-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--play",
      toString: function () {
        return this.url;
      }
    }